import { observer } from "mobx-react"
import * as React from "react"
import { MembersStep } from "./MembersStep"
import { MembersEditorComp } from "./MembersEditorComp"
import theme from "../../theme"
import { Flex, Text, Button } from "rebass"
import StyledCard from "../../components/StyledCard"

@observer
export class MembersStepComp extends React.Component<{
  model: MembersStep
}> {
  render() {
    const { model } = this.props

    const children = [
      <Flex
        id="membersParent"
        flexDirection="column"
        justifyContent="space-between"
        alignItems="space-around"
        width={["95vw", 0.95, 0.95, 900]}
        key={0}
      >
        {model.shouldShowMembersEditor && (
          <StyledCard
            id="members-card"
            m={2}
            p={3}
            style={{
              width: "100%",
              maxWidth: 900,
              alignSelf: "flex-start",
              backgroundColor: theme.colors.black
            }}
          >
            <Flex
              flexDirection={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              p={2}
              width={1}
              my={3}
            >
              <Flex alignItems="center" color={theme.colors.white} mt={2}>
                <Text
                  color={theme.colors.white}
                  mb={2}
                  ml={3}
                  fontSize={["1.2rem", "1.2rem", "2rem"]}
                >
                  Members Of Your Group ({model.memberList.length})
                </Text>
              </Flex>
              <Button
                className="add-member"
                p={2}
                mr={3}
                fontSize={20}
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: "bold",
                  cursor: "pointer",
                  background: theme.colors.callToAction,
                  borderRadius: 4
                }}
                onClick={() => {
                  model.editNewMember()
                }}
              >
                <i
                  style={{
                    marginRight: 3,
                    fontSize: window.innerWidth > 450 ? "1.2rem" : "0.75rem"
                  }}
                  className="fas fa-plus"
                />
                <i
                  style={{
                    marginRight: 10,
                    fontSize: window.innerWidth > 450 ? "1.2rem" : "0.75rem"
                  }}
                  className="fas fa-user"
                />
                Add
              </Button>
            </Flex>
            <MembersEditorComp model={model} />
          </StyledCard>
        )}
      </Flex>
    ]

    return (
      <Flex
        id="members-step-comp"
        width={1}
        flexDirection="column"
        alignItems="center"
        p={2}
      >
        {children}
      </Flex>
    )
  }
}
